import { interopDefault } from '~/router/utils'
import { smoothenRoutesScroll } from '~/utils/router'

export const auditsPackagesRoutes = smoothenRoutesScroll([
  {
    path: 'audits/packages',
    name: '__account_audits_packages',
    component: () =>
      interopDefault(
        import(
          '~/pages/account/audits/packages/index.vue' /* webpackChunkName: "pages-account-audits-packages-index.vue" */
        )
      )
  },
  {
    path: 'audits/packages/new',
    name: '__account_audits_packages_new',
    component: () =>
      interopDefault(
        import(
          '~/pages/account/audits/packages/new.vue' /* webpackChunkName: "pages-account-audits-packages-new.vue" */
        )
      ),
    meta: {
      noBackTopMenu: true
    }
  },
  {
    path: 'audits/packages/:packageId',
    name: '__account_audits_packages_edit',
    component: () =>
      interopDefault(
        import(
          '~/pages/account/audits/packages/edit.vue' /* webpackChunkName: "pages-account-audits-packages-edit.vue" */
        )
      ),
    meta: {
      noBackTopMenu: true
    }
  }
])
